export const REQUEST_FUNERAL_LIST = "REQUEST_FUNERAL_LIST"